<section class="sh-dialog__content">
    <p class="sh-clear-margin-top">{{ messageKey | translate }}</p>

    <p>
        {{ followMessageKey | translate }}<a [href]="batchesLink">{{ managementKey | translate }}</a>
    </p>
</section>
<footer class="sh-dialog__footer">
    <div class="sh-action-group -sh-align-end">
        <button type="button" class="sh-button sh-action-group__item" (click)="submit()">{{ yesKey | translate }}</button>
    </div>
</footer>
